import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { recordActions } from '../configuration/react';

const useVersions = (recordId) => {
  const isLoading = useSelector((state) => state.reduxRecords?.loading);
  const versions = useSelector((state) => state.reduxRecords.data[recordId]?.vehicle?.versionsData);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(recordActions.getVehicleVersions(recordId));
  }, [recordId]);

  return { versions, isLoading };
};

export default useVersions;
